import { IconDefinition } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

type ObjectMap = {
    [key in ObjectType]: {
        label: ObjectsNamesSinglular
        labelPlural: ObjectsNames
        icon: IconDefinition
        iconActive: IconDefinition
    }
}

export const objectMap: ObjectMap = {
    estimate: {
        label: "Estimate",
        labelPlural: "Estimates",
        icon: faIcon({ name: "clock", style: "regular" }),
        iconActive: faIcon({ name: "clock", style: "solid" }),
    },
    client: {
        label: "Client",
        labelPlural: "Clients",
        icon: faIcon({ name: "building-user", style: "regular" }),
        iconActive: faIcon({ name: "building-user", style: "solid" }),
    },
    job: {
        label: "Job",
        labelPlural: "Jobs",
        icon: faIcon({ name: "wrench-simple", style: "regular" }),
        iconActive: faIcon({ name: "wrench-simple", style: "solid" }),
    },
    job_series: {
        label: "Job Series",
        labelPlural: "Job series",
        icon: faIcon({ name: "wrench-simple", style: "regular" }),
        iconActive: faIcon({ name: "wrench-simple", style: "solid" }),
    },
    invoice: {
        label: "Invoice",
        labelPlural: "Invoices",
        icon: faIcon({ name: "circle-dollar", style: "regular" }),
        iconActive: faIcon({ name: "circle-dollar", style: "solid" }),
    },
    credit_note: {
        label: "Credit Note",
        labelPlural: "Credit notes",
        icon: faIcon({ name: "circle-dollar", style: "regular" }),
        iconActive: faIcon({ name: "circle-dollar", style: "solid" }),
    },
    purchase_order: {
        label: "Purchase Order",
        labelPlural: "Purchase orders",
        icon: faIcon({ name: "basket-shopping", style: "regular" }),
        iconActive: faIcon({ name: "basket-shopping", style: "solid" }),
    },
    bill: {
        label: "Bill",
        labelPlural: "Bills",
        icon: faIcon({ name: "file-invoice-dollar", style: "regular" }),
        iconActive: faIcon({ name: "file-invoice-dollar", style: "solid" }),
    },
    vendor_credit: {
        label: "Vendor Credit",
        labelPlural: "Vendor credits",
        icon: faIcon({ name: "file-invoice-dollar", style: "regular" }),
        iconActive: faIcon({ name: "file-invoice-dollar", style: "solid" }),
    },
    pricebook_item: {
        label: "Pricebook Item",
        labelPlural: "Pricebook",
        icon: faIcon({ name: "tag", style: "regular" }),
        iconActive: faIcon({ name: "tag", style: "solid" }),
    },
    labor: {
        label: "Labor Rate",
        labelPlural: "Labor rates",
        icon: faIcon({ name: "tag", style: "regular" }),
        iconActive: faIcon({ name: "tag", style: "solid" }),
    },
    product: {
        label: "Product",
        labelPlural: "Products",
        icon: faIcon({ name: "box-taped", style: "regular" }),
        iconActive: faIcon({ name: "box-taped", style: "solid" }),
    },
    other: {
        label: "Other",
        labelPlural: "Other",
        icon: faIcon({ name: "tag", style: "regular" }),
        iconActive: faIcon({ name: "tag", style: "solid" }),
    },
    discount: {
        label: "Discount",
        labelPlural: "Discounts",
        icon: faIcon({ name: "tag", style: "regular" }),
        iconActive: faIcon({ name: "tag", style: "solid" }),
    },
    tax_rate: {
        label: "Tax Rate",
        labelPlural: "Tax rates",
        icon: faIcon({ name: "percent", style: "regular" }),
        iconActive: faIcon({ name: "percent", style: "solid" }),
    },
    warranty: {
        label: "Warranty",
        labelPlural: "Warranties",
        icon: faIcon({ name: "shield-halved", style: "regular" }),
        iconActive: faIcon({ name: "shield-halved", style: "solid" }),
    },
    vendor: {
        label: "Vendor",
        labelPlural: "Vendors",
        icon: faIcon({ name: "store", style: "regular" }),
        iconActive: faIcon({ name: "store", style: "solid" }),
    },
    catalog_item: {
        label: "Catalog Item",
        labelPlural: "Catalog items",
        icon: faIcon({ name: "shelves", style: "regular" }),
        iconActive: faIcon({ name: "shelves", style: "solid" }),
    },
    location: {
        label: "Location",
        labelPlural: "Locations",
        icon: faIcon({ name: "location-dot", style: "regular" }),
        iconActive: faIcon({ name: "location-dot", style: "solid" }),
    },
    file: {
        label: "File",
        labelPlural: "Files",
        icon: faIcon({ name: "file", style: "regular" }),
        iconActive: faIcon({ name: "file", style: "solid" }),
    },
    equipment: {
        label: "Equipment",
        labelPlural: "Equipment",
        icon: faIcon({ name: "cube", style: "regular" }),
        iconActive: faIcon({ name: "cube", style: "solid" }),
    },
    visit: {
        label: "Visit",
        labelPlural: "Visits",
        icon: faIcon({ name: "calendar", style: "regular" }),
        iconActive: faIcon({ name: "calendar", style: "solid" }),
    },
}
